import * as constants from '../constants'

const initialState = {
  ocppTags: { ocppTagList: [] },
}

export function ocppTagsReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_OCPPTAGS:
      return {
        ...state,
        ocppTags: action.ocppTags,
      }

    default:
      return state
  }
}
